import { useRef, useEffect, useState } from 'react'
import * as rive from '@rive-app/canvas'
import { useInView } from 'framer-motion'
import { ELITE_RIVE_URL } from '../../constants'

enum RiveFit {
  HEIGHT = rive.Fit.FitHeight,
  WIDTH = rive.Fit.FitWidth,
  FILL = rive.Fit.Fill,
  CONTAIN = rive.Fit.Contain
}

const AutoPlayRiveComponent = ({
  riveUrl,
  riveFit = RiveFit.CONTAIN,
  isLoop = false,
  isRedrawRive = true,
  title = '',
  onRiveLoad
}: {
  riveUrl: string
  riveFit?: `${RiveFit}`
  isLoop?: boolean
  isRedrawRive?: boolean
  title?: string
  onRiveLoad?: () => void
}) => {
  const riveInstance = useRef<rive.Rive | null>(null)
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const isInView = useInView(canvasRef, { once: true, amount: 1 })
  const [stateMachine, setStateMachine] = useState('idle')

  function redrawRive() {
    if (riveInstance && riveInstance.current) riveInstance.current.resizeDrawingSurfaceToCanvas()
  }

  function createRiveInstance() {
    riveInstance.current = new rive.Rive({
      src: `${ELITE_RIVE_URL}${riveUrl}`,
      canvas: canvasRef?.current as HTMLCanvasElement,
      stateMachines: stateMachine,
      onLoop: () => {
        // if (!isLoop) setStateMachine('idle')
      },
      onStop: () => {
        // triggerResultRiveLoaded()
      },
      onLoad: (event) => {
        if (onRiveLoad) onRiveLoad()
        if (isRedrawRive) redrawRive()
      }
    })

    riveInstance.current.layout = new rive.Layout({ fit: riveFit as any })
  }

  useEffect(() => {
    riveInstance?.current?.cleanup()
    createRiveInstance()
    riveInstance?.current?.play()
  }, [stateMachine])

  useEffect(() => {
    if (isLoop) setStateMachine('animation_loop')
    else if (isInView) setStateMachine('animation_single')
  }, [isInView, isLoop])

  useEffect(() => {
    window.addEventListener('resize', redrawRive, false)
    return () => {
      window.removeEventListener('resize', redrawRive, false)
    }
  }, [])

  return <canvas ref={canvasRef} id='canvas' className='w-full h-full' />
}

export default AutoPlayRiveComponent
